import { memo, useEffect } from "react";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import ".././inner.css";
import { LazyLoadImage } from "react-lazy-load-image-component";

function JointReplacement() {
  useEffect(() => {
    document.title = "Joint Replacement Services | Viksha Health Care";
    const newMetaDescription =
      "Joint replacement services at Viksha Health Care. Evaluation, surgical planning, and post-operative rehabilitation support for better mobility.";
    const metaTag = document.querySelector('meta[name="description"]');
    if (metaTag) {
      metaTag.setAttribute("content", newMetaDescription);
    }
  }, []);

  return (
    <>
      <h2 style={{ fontSize: "0px" }}>Joint Replacement Services</h2>
      <div className="serinfobox">
        <div className="serinfoimg">
          <LazyLoadImage src="/photo/Joint-Replacement-Services.avif" />
        </div>
        <div className="textareaofser">
          <h1>Joint Replacement Services</h1>

          <p>
            Joint replacement surgery is a treatment option for individuals with
            severe joint pain and stiffness that limits daily activities. When
            non-surgical treatments no longer provide relief, replacing the
            damaged joint surfaces can help restore movement and reduce pain.
          </p>

          <p>
            The most commonly replaced joints are the knee and hip, but other
            joints may also be considered depending on the condition.
          </p>

          <h5>When Is Joint Replacement Recommended?</h5>
          <ul>
            <li>Severe arthritis causing persistent pain</li>
            <li>Joint stiffness that limits daily activities</li>
            <li>Joint damage due to injury or deformity</li>
            <li>
              Pain that does not improve with medications or physiotherapy
            </li>
            <li>Reduced quality of life due to joint problems</li>
          </ul>

          <h5>Types of Joint Replacement</h5>

          <h6>Total Joint Replacement</h6>
          <p>
            In total joint replacement, damaged joint surfaces are removed and
            replaced with artificial components designed to restore smooth
            movement.
          </p>

          <h6>Partial Joint Replacement</h6>
          <p>
            In some cases, only the damaged portion of the joint is replaced,
            preserving healthy structures and allowing more natural joint
            function.
          </p>

          <h5>Benefits of Joint Replacement</h5>
          <ul>
            <li>Significant pain relief</li>
            <li>Improved joint movement and flexibility</li>
            <li>Better ability to perform daily activities</li>
            <li>Enhanced overall quality of life</li>
          </ul>

          <h5>Preparation Before Surgery</h5>
          <p>
            Before surgery, a thorough evaluation is done to assess overall
            health. Patients receive guidance on exercises, medications, and
            lifestyle measures that help improve surgical outcomes.
          </p>

          <h5>Recovery and Rehabilitation</h5>
          <p>
            After surgery, physiotherapy plays an important role in regaining
            strength and mobility. Gradual return to normal activities is
            encouraged under professional guidance.
          </p>

          <h5>Long-Term Care</h5>
          <p>
            Maintaining a healthy weight, staying active with low-impact
            exercises, and following medical advice can help ensure the
            longevity of the replaced joint.
          </p>

          <p>
            Joint replacement services aim to relieve pain, restore mobility,
            and help individuals return to an active and independent lifestyle.
          </p>
        </div>
      </div>
    </>
  );
}

export default memo(JointReplacement);
